var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M20.351,3.063l-8-3a1.009,1.009,0,0,0-.7,0l-8,3A1,1,0,0,0,3,4V23a1,1,0,0,0,1,1h6V19h4v5h6a1,1,0,0,0,1-1V4A1,1,0,0,0,20.351,3.063ZM8,16H6V13H8Zm0-6H6V7H8Zm5,6H11V13h2Zm0-6H11V7h2Zm5,6H16V13h2Zm0-6H16V7h2Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }